import axios from "axios";
import * as API_LINKS from '../../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_WORKSHOP_OH_TABLE = 'FETCH_WORKSHOP_OH_TABLE'
export const RECEIVE_WORKSHOP_OH_TABLE = 'RECEIVE_WORKSHOP_OH_TABLE'
export const FAILED_WORKSHOP_OH_TABLE = 'FAILED_WORKSHOP_OH_TABLE'

export function fetchWorkshopOperationalHour(id_workshop){


    return (dispatch, getState) => {
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_WORKSHOP_OH_TABLE});
        axios({
            method: 'post',
            url: API_LINKS.WORKSHOP_OH_LIST_URL,
            headers: {
                Authorization: auth
            },
            data:{
                id_workshop: id_workshop
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_WORKSHOP_OH_TABLE,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_WORKSHOP_OH_TABLE
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_WORKSHOP_OH_TABLE
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_WORKSHOP_OH_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_WORKSHOP_OH_TABLE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_WORKSHOP_OH_TABLE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_WORKSHOP_OH_TABLE
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}